var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("Макет")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-value": "value",
                  "item-text": "title",
                  "return-object": "",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.layout,
                  items: _vm.$options.layoutsList,
                },
                on: {
                  change: function ($event) {
                    return _vm.mixChangeListItemHandler($event.value, "layout")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-row", { attrs: { "no-gutters": "" } }, [_c("v-divider")], 1),
      _c(
        "v-row",
        { staticClass: "mt-5 mb-10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _c("span", [
                _vm._v(
                  "Список: (" + _vm._s(_vm.listItem.data.images.length) + ")"
                ),
              ]),
              _c("ErrorMessage", {
                attrs: { message: _vm.errorMessages.images },
              }),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: {
                small: "",
                disabled: _vm.isLoading,
                loading: _vm.isLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.mixAddListItemItemHandler(
                    "images",
                    _vm.$options.widgetItems
                  )
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v(" mdi-plus ")])],
            1
          ),
        ],
        1
      ),
      _vm._l(
        _vm.listItem.data.images,
        function (listItemItem, listItemItemIndex) {
          return _c(
            "v-row",
            {
              key: listItemItemIndex,
              staticClass: "mb-5",
              attrs: { align: "center" },
            },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    "max-width": "100%",
                    flat: "",
                    color: "transparent",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-row",
                        {
                          attrs: { align: "center", justify: "space-between" },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " Карточка " +
                                _vm._s(listItemItemIndex + 1) +
                                ": "
                            ),
                          ]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                small: "",
                                disabled: _vm.isLoading,
                                loading: _vm.isLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixRemoveListItemItemHandler(
                                    listItemItemIndex,
                                    "images"
                                  )
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { color: "red" } }, [
                                _vm._v("mdi-trash-can-outline"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: { "no-gutters": "", align: "center" },
                                },
                                [
                                  _c("MediaFilePicker", {
                                    attrs: {
                                      multiple: false,
                                      label: "Медиа файл",
                                      "file-type":
                                        _vm.$options.mediaTypesByKeys.IMAGE,
                                      value: listItemItem.data.image
                                        ? listItemItem.data.image.id
                                        : listItemItem.data.image,
                                      isShowCaption: true,
                                      caption: listItemItem.data.caption,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.addImageHandler(
                                          $event,
                                          listItemItemIndex
                                        )
                                      },
                                      "change-caption": function ($event) {
                                        return _vm.mixChangeListItemItemHandler(
                                          $event,
                                          "images",
                                          listItemItemIndex,
                                          "caption"
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "preview-bottom",
                                          fn: function () {
                                            return [
                                              _c("ErrorMessage", {
                                                attrs: {
                                                  message: _vm.errorMessages[
                                                    listItemItemIndex
                                                  ]
                                                    ? _vm.errorMessages[
                                                        listItemItemIndex
                                                      ].image
                                                    : "",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "span",
                                [
                                  _vm._v("Заголовок ("),
                                  _c("TranslationIcon"),
                                  _vm._v(")"),
                                ],
                                1
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.title,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "images",
                                      listItemItemIndex,
                                      "title"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "span",
                                [
                                  _vm._v("Описание ("),
                                  _c("TranslationIcon"),
                                  _vm._v(")"),
                                ],
                                1
                              ),
                              _c("v-textarea", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.description,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "images",
                                      listItemItemIndex,
                                      "description"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("span", [_vm._v("Ссылка")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.link,
                                  "error-messages": _vm.errorMessages[
                                    listItemItemIndex
                                  ]
                                    ? _vm.errorMessages[listItemItemIndex].link
                                    : "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "images",
                                      listItemItemIndex,
                                      "link"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }